export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 rounded-2xl p-8 md:p-12 overflow-hidden relative">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-10 right-10 w-40 h-40 rounded-full bg-white/30 blur-3xl"></div>
            <div className="absolute bottom-10 left-10 w-32 h-32 rounded-full bg-white/20 blur-3xl"></div>
          </div>
          <div className="relative flex flex-col lg:flex-row items-center gap-8">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl text-white mb-3">随时随地，想吃就吃</h2>
              <p className="text-white/80 text-sm md:text-base leading-relaxed mb-6 max-w-md">
                52吃瓜网移动端已覆盖iOS与Android双平台，支持推送通知、离线阅读和夜间模式。地铁上、等餐时、睡前刷一刷，不错过每一个热瓜。
              </p>
              <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
                <a href="#app" className="inline-flex items-center gap-2 px-5 py-2.5 bg-white text-primary-600 rounded-full text-sm font-medium hover:bg-white/90 transition-colors whitespace-nowrap cursor-pointer">
                  <i className="ri-apple-fill text-lg"></i>
                  App Store 下载
                </a>
                <a href="#app" className="inline-flex items-center gap-2 px-5 py-2.5 bg-white/20 text-white border border-white/30 rounded-full text-sm font-medium hover:bg-white/30 transition-colors whitespace-nowrap cursor-pointer">
                  <i className="ri-android-fill text-lg"></i>
                  Android 下载
                </a>
              </div>
            </div>
            <div className="shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20modern%20smartphone%20mockup%20showing%20a%20news%20app%20interface%20with%20warm%20coral%20and%20cream%20color%20scheme%2C%20minimalist%20UI%20design%2C%20floating%20phone%20on%20transparent%20background%2C%20soft%20lighting&width=400&height=560&seq=app-mockup-2026-x1&orientation=portrait"
                alt="52吃瓜网移动端应用界面"
                className="w-48 md:w-56 h-auto object-contain"
                onError={(e) => {
                  const t = e.currentTarget;
                  t.style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}